(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["app-screenshots"] && !Shopify.designMode) return;
  try {
    
  const initializeAppCarousel = (carousel) => {
    if (carousel.dataset.carouselReady) return;
    carousel.dataset.carouselReady = 'true';

    const viewport = carousel.querySelector('[data-app-carousel-viewport]');
    const track = carousel.querySelector('[data-app-carousel-track]');
    const status = carousel.querySelector('[data-app-carousel-status]');
    const slides = Array.from(track.querySelectorAll('[data-app-carousel-slide]'));
    if (slides.length < 2) return;
    const previous = carousel.querySelector('[data-app-carousel-prev]');
    const next = carousel.querySelector('[data-app-carousel-next]');
    const desktopPointer = window.matchMedia('(min-width: 701px)');
    let activeIndex = 0;
    let dragStart = null;
    let suppressClick = false;

    const targetOffset = (slide) => slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
    const closestIndex = () => {
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let nearest = 0;
      let distance = Infinity;
      slides.forEach((slide, index) => {
        const difference = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - center);
        if (difference < distance) {
          distance = difference;
          nearest = index;
        }
      });
      return nearest;
    };
    const focus = (index) => {
      activeIndex = index;
      slides.forEach((slide, slideIndex) => {
        const focused = slideIndex === index;
        slide.classList.toggle('is-active', focused);
        const select = slide.querySelector('[data-app-carousel-select]');
        if (focused) select.setAttribute('aria-current', 'true');
        else select.removeAttribute('aria-current');
      });
      previous.disabled = index === 0;
      next.disabled = index === slides.length - 1;
      status.textContent = slides[index].querySelector('figcaption').textContent.trim();
    };
    const goTo = (index, behavior = 'smooth') => {
      const destination = Math.max(0, Math.min(slides.length - 1, index));
      focus(destination);
      viewport.scrollTo({ left: targetOffset(slides[destination]), behavior });
    };
    const sizeEdges = () => {
      track.style.setProperty('--carousel-edge', `${Math.max(0, (viewport.clientWidth - slides[0].offsetWidth) / 2)}px`);
      goTo(activeIndex, 'auto');
    };

    previous.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));
    track.addEventListener('click', (event) => {
      const select = event.target.closest('[data-app-carousel-select]');
      if (select) goTo(slides.indexOf(select.closest('[data-app-carousel-slide]')));
    });
    const finishDrag = () => {
      if (!dragStart) return;
      const moved = dragStart.moved;
      dragStart = null;
      window.removeEventListener('pointermove', moveDrag);
      window.removeEventListener('pointerup', finishDrag);
      window.removeEventListener('pointercancel', finishDrag);
      viewport.classList.remove('is-dragging');
      if (moved) {
        suppressClick = true;
        window.setTimeout(() => { suppressClick = false; }, 0);
        requestAnimationFrame(() => goTo(closestIndex()));
      }
    };
    const moveDrag = (event) => {
      if (!dragStart) return;
      const distance = event.clientX - dragStart.x;
      if (!dragStart.moved && Math.abs(distance) <= 5) return;
      dragStart.moved = true;
      viewport.classList.add('is-dragging');
      viewport.scrollLeft = dragStart.scrollLeft - distance;
      event.preventDefault();
    };
    viewport.addEventListener('pointerdown', (event) => {
      if (!desktopPointer.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
      dragStart = { x: event.clientX, scrollLeft: viewport.scrollLeft, moved: false };
      window.addEventListener('pointermove', moveDrag);
      window.addEventListener('pointerup', finishDrag);
      window.addEventListener('pointercancel', finishDrag);
    });
    viewport.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, true);
    viewport.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    viewport.addEventListener('scroll', () => focus(closestIndex()), { passive: true });
    viewport.addEventListener('scrollend', () => focus(closestIndex()));
    new ResizeObserver(sizeEdges).observe(viewport);
    sizeEdges();
    carousel.classList.add('is-ready');
  };

  document.querySelectorAll('[data-app-carousel]').forEach(initializeAppCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('[data-app-carousel]')) initializeAppCarousel(event.target);
    event.target.querySelectorAll('[data-app-carousel]').forEach(initializeAppCarousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    let returnFocus;
    const rootPath = window.Shopify?.routes?.root || '/';
    const drawer = () => document.querySelector('[data-cart-drawer]');
    const focusable = () => drawer()?.querySelector('.cart-drawer__panel')?.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    const setCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });
    };
    const open = (trigger) => {
      const current = drawer();
      if (!current) return;
      returnFocus = trigger || document.activeElement;
      current.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
      current.querySelector('[data-cart-close-button]')?.focus();
    };
    const close = () => {
      const current = drawer();
      if (!current) return;
      current.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-open');
      returnFocus?.focus?.();
    };
    const showError = (message) => {
      const target = drawer()?.querySelector('[data-cart-error]');
      if (!target) return;
      target.textContent = message;
      target.hidden = false;
    };
    const refresh = async (keepOpen = true) => {
      const [htmlResponse, cartResponse] = await Promise.all([
        fetch(`${rootPath}cart?section_id=cart-drawer`),
        fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } })
      ]);
      if (!htmlResponse.ok || !cartResponse.ok) throw new Error(drawer()?.dataset.refreshError);
      const html = await htmlResponse.text();
      const cart = await cartResponse.json();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsed.querySelector('[data-cart-drawer-section]');
      const current = drawer();
      if (replacement && current) current.replaceWith(replacement);
      setCount(cart.item_count);
      if (keepOpen) open(returnFocus);
      return cart;
    };
    document.addEventListener('click', async (event) => {
      const openButton = event.target.closest('[data-cart-open]');
      if (openButton) {
        event.preventDefault();
        open(openButton);
        return;
      }
      if (event.target.closest('[data-cart-close]')) {
        close();
        return;
      }
      const changeButton = event.target.closest('[data-cart-change]');
      if (!changeButton) return;
      changeButton.disabled = true;
      try {
        const response = await fetch(`${rootPath}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: changeButton.dataset.lineKey, quantity: Number(changeButton.dataset.quantity) })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        await refresh(true);
      } catch (error) {
        showError(error.message);
        changeButton.disabled = false;
      }
    });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const errorTarget = form.querySelector('[data-product-error]');
      if (submit) submit.disabled = true;
      if (errorTarget) errorTarget.hidden = true;
      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message);
        returnFocus = submit;
        await refresh(true);
        const updatedDrawer = drawer();
        updatedDrawer?.querySelector('[data-cart-status]')?.replaceChildren(document.createTextNode(updatedDrawer.dataset.addedMessage));
      } catch (error) {
        if (errorTarget) {
          errorTarget.textContent = error.message;
          errorTarget.hidden = false;
        }
      } finally {
        if (submit) submit.disabled = false;
      }
    });
    document.addEventListener('keydown', (event) => {
      const current = drawer();
      if (!current || current.getAttribute('aria-hidden') === 'true') return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      const items = [...focusable()];
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-action]');
    if (!button) return;
    const input = button.closest('.cart-line__stepper')?.querySelector('input[name="updates[]"]');
    if (!input) return;
    if (button.dataset.cartQuantityAction === 'increase') {
      input.stepUp();
    } else {
      input.stepDown();
    }
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-footer-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  const revealItems = document.querySelectorAll('[data-reveal]');
  document.querySelectorAll('main section').forEach((section) => {
    section.querySelectorAll('[data-reveal]').forEach((item, index) => {
      if (!item.style.getPropertyValue('--delay')) item.style.setProperty('--delay', `${Math.min(index * 70, 350)}ms`);
    });
  });
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-site-header]');
  const toggle = header?.querySelector('[data-menu-toggle]');
  const themeToggle = header?.querySelector('[data-theme-toggle]');
  const appearanceQuery = window.matchMedia('(prefers-color-scheme: light)');
  const updateThemeColor = (appearance) => {
    const themeColor = document.querySelector('[data-theme-color]');
    if (themeColor) themeColor.content = themeColor.dataset[appearance];
  };
  const updateThemeToggle = (appearance) => {
    const label = appearance === 'dark' ? themeToggle?.dataset.lightLabel : themeToggle?.dataset.darkLabel;
    if (!themeToggle || !label) return;
    themeToggle.setAttribute('aria-label', label);
    themeToggle.setAttribute('title', label);
  };
  const applyAppearance = (appearance, preference) => {
    document.documentElement.dataset.theme = appearance;
    document.documentElement.dataset.themePreference = preference;
    document.documentElement.style.colorScheme = appearance;
    updateThemeColor(appearance);
    updateThemeToggle(appearance);
  };
  updateThemeToggle(document.documentElement.dataset.theme || (appearanceQuery.matches ? 'light' : 'dark'));
  themeToggle?.addEventListener('click', () => {
    const currentAppearance = document.documentElement.dataset.theme || (appearanceQuery.matches ? 'light' : 'dark');
    const nextAppearance = currentAppearance === 'dark' ? 'light' : 'dark';
    try {
      localStorage.setItem('mi8os-theme', nextAppearance);
    } catch (error) {
      document.documentElement.dataset.themePreference = 'user';
    }
    applyAppearance(nextAppearance, 'user');
  });
  appearanceQuery.addEventListener('change', (event) => {
    if (document.documentElement.dataset.themePreference !== 'system') return;
    applyAppearance(event.matches ? 'light' : 'dark', 'system');
  });
  let lockedScrollY = null;
  const updateHeader = () => {
    if (lockedScrollY !== null) return;
    header?.classList.toggle('is-scrolled', window.scrollY > 24);
  };
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  const lockPageScroll = (lock) => {
    const root = document.documentElement;
    const body = document.body;
    if (lock && lockedScrollY === null) {
      lockedScrollY = window.scrollY;
      body.style.top = `-${lockedScrollY}px`;
      root.classList.add('menu-open');
      body.classList.add('menu-open');
    } else if (!lock && lockedScrollY !== null) {
      const scrollY = lockedScrollY;
      lockedScrollY = null;
      root.classList.remove('menu-open');
      body.classList.remove('menu-open');
      body.style.top = '';
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    }
  };
  const setMobileMenuOpen = (open) => {
    header.classList.toggle('is-open', open);
    lockPageScroll(open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
  };
  toggle?.addEventListener('click', () => {
    const open = !header.classList.contains('is-open');
    setMobileMenuOpen(open);
  });
  header?.querySelectorAll('.mobile-menu a').forEach((link) => link.addEventListener('click', () => {
    setMobileMenuOpen(false);
  }));
  window.matchMedia('(min-width: 1051px)').addEventListener('change', (event) => {
    if (event.matches && header?.classList.contains('is-open')) setMobileMenuOpen(false);
  });
  header?.querySelectorAll('[data-learn-menu]').forEach((menu) => {
    const summary = menu.querySelector('summary');
    menu.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(menu.open)));
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => menu.removeAttribute('open')));
    summary?.setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', (event) => {
    header?.querySelectorAll('.site-header__learn [data-learn-menu][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  header?.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = header.querySelector('[data-learn-menu][open]');
    if (openMenu) {
      openMenu.removeAttribute('open');
      openMenu.querySelector('summary')?.focus();
      return;
    }
    if (header.classList.contains('is-open')) {
      setMobileMenuOpen(false);
      toggle?.focus();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meta-landing"]) return;
  try {
    
  document.querySelectorAll('[data-meta-landing]').forEach((root) => {
    // The ad video autoplays muted; this button turns its sound on and off.
    const reel = root.querySelector('[data-lp-reel] video');
    const sound = root.querySelector('[data-lp-sound]');
    if (reel && sound) {
      sound.addEventListener('click', () => {
        reel.muted = !reel.muted;
        if (!reel.muted) reel.play().catch(() => {});
        sound.setAttribute('aria-pressed', String(!reel.muted));
        sound.setAttribute('aria-label', reel.muted ? sound.dataset.labelOn : sound.dataset.labelOff);
      });
    }

    const video = root.querySelector('[data-lp-video]');
    if (video && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: .35 }).observe(video);
    }

    // The card stack follows the pointer on desktop and drifts on its own on touch screens, like the product page.
    const stage = root.querySelector('[data-lp-stack-stage]');
    const stack = stage?.querySelector('[data-product-card-stack]');
    if (stage && stack) {
      const apply = (x, y, damp) => {
        stack.style.setProperty('--rx', `${(-y * 6 * damp).toFixed(3)}deg`);
        stack.style.setProperty('--ry', `${(x * 8 * damp).toFixed(3)}deg`);
        stack.style.setProperty('--sheen', `${(50 + x * 40 * damp).toFixed(2)}`);
        stage.style.setProperty('--pointer-x', `${(50 + x * 50 * damp).toFixed(2)}%`);
        stage.style.setProperty('--pointer-y', `${(45 + y * 40 * damp).toFixed(2)}%`);
      };
      if (matchMedia('(pointer: fine)').matches) {
        let targetX = 0, targetY = 0, currentX = 0, currentY = 0, frame = 0;
        const step = () => {
          frame = 0;
          currentX += (targetX - currentX) * .075;
          currentY += (targetY - currentY) * .075;
          apply(currentX, currentY, 1);
          if (Math.abs(targetX - currentX) > .001 || Math.abs(targetY - currentY) > .001) frame = requestAnimationFrame(step);
        };
        stage.addEventListener('pointermove', (event) => {
          const bounds = stage.getBoundingClientRect();
          targetX = ((event.clientX - bounds.left) / bounds.width - .5) * 2;
          targetY = ((event.clientY - bounds.top) / bounds.height - .5) * 2;
          if (!frame) frame = requestAnimationFrame(step);
        }, { passive: true });
        stage.addEventListener('pointerleave', () => { targetX = 0; targetY = 0; if (!frame) frame = requestAnimationFrame(step); });
      } else {
        let visible = false, frame = 0;
        const loop = (time) => {
          if (!visible) { frame = 0; return; }
          const phase = time / 1800;
          apply(Math.sin(phase) * .5, Math.cos(phase * .82) * .4, 1);
          frame = requestAnimationFrame(loop);
        };
        new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (visible && !frame) frame = requestAnimationFrame(loop);
        }, { rootMargin: '120px' }).observe(stage);
      }
    }

    // The bar shows on phones once the hero button has scrolled away and hides again over the offer.
    const bar = root.querySelector('[data-lp-bar]');
    const heroBuy = root.querySelector('.lp-hero__buy');
    const offer = root.querySelector('#Offer');
    if (!bar || !heroBuy || !offer) return;
    let heroVisible = true;
    let offerVisible = false;
    const sync = () => {
      const visible = !heroVisible && !offerVisible;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      bar.inert = !visible;
    };
    new IntersectionObserver(([entry]) => { heroVisible = entry.isIntersecting; sync(); }).observe(heroBuy);
    new IntersectionObserver(([entry]) => { offerVisible = entry.isIntersecting; sync(); }, { threshold: .2 }).observe(offer);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mi8os-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // After the first two sections the language pill (bottom left) turns into the buy bar:
    // the bar starts clipped to the pill's rectangle and opens out while the pill fades.
    const trigger = document.querySelector('[data-create]');
    const bar = document.querySelector('[data-home-purchase]');
    const pill = document.getElementById('HomeLanguagePillForm');
    if (!trigger || !bar) return;
    let visible = null;
    let frame = 0;
    const measure = () => {
      const b = bar.getBoundingClientRect();
      const r = pill?.getBoundingClientRect();
      const p = r && r.width ? r : { left: 20, width: 72, top: innerHeight - 71.6, bottom: innerHeight - 20 };
      // Undo the current translate so the numbers describe the bar's resting place.
      const shift = visible ? 0 : parseFloat(getComputedStyle(bar).getPropertyValue('--morph-x')) || 0;
      const left = b.left - shift;
      bar.style.setProperty('--morph-x', `${(p.left - left).toFixed(2)}px`);
      bar.style.setProperty('--morph-top', `${Math.max(0, p.top - b.top).toFixed(2)}px`);
      bar.style.setProperty('--morph-bottom', `${Math.max(0, b.bottom - p.bottom).toFixed(2)}px`);
      bar.style.setProperty('--morph-right', `${Math.max(0, b.width - p.width).toFixed(2)}px`);
    };
    const sync = () => {
      frame = 0;
      const next = trigger.getBoundingClientRect().top < innerHeight * .5;
      if (next === visible) return;
      if (next) {
        measure();
      } else if (bar.classList.contains('is-settled')) {
        // Put the clip back (no animation) so the shrink into the pill can animate from it.
        bar.classList.remove('is-settled');
        void bar.offsetWidth;
      }
      visible = next;
      bar.classList.toggle('is-visible', next);
      bar.setAttribute('aria-hidden', String(!next));
      bar.inert = !next;
      if (pill) {
        pill.classList.toggle('is-hidden', next);
        pill.inert = next;
        if (next && pill.contains(document.activeElement)) document.activeElement.blur();
      }
    };
    bar.addEventListener('transitionend', (event) => {
      if (event.target === bar && event.propertyName === 'clip-path' && visible) bar.classList.add('is-settled');
    });
    const queue = () => { if (!frame) frame = requestAnimationFrame(sync); };
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', () => { if (!visible) measure(); queue(); });
    measure();
    sync();
  })();

  (() => {
    // Mobile tiles open on tap; desktop videos play only while their tile is hovered.
    const grid = document.querySelector('.home-highlights__grid');
    if (!grid) return;
    const tiles = [...grid.querySelectorAll('[data-home-tile]')];
    const byName = new Map(tiles.map((tile) => [tile.dataset.homeTile, tile]));
    const mobileOrder = ['hold', 'phone', 'three', 'offline', 'ready', 'cipher'].map((name) => byName.get(name));
    const phone = matchMedia('(max-width: 900px)');
    const maxVideoPlays = 10;
    let wasMobile = phone.matches;
    const createVideoController = (tile) => {
      const video = tile?.querySelector('[data-home-tile-video]');
      if (!video) return null;
      let visible = false;
      let hovered = false;
      let completedPlays = 0;
      let frameRequest = 0;
      let loading = false;
      let ready = false;
      const seamlessLoop = video.hasAttribute('data-seamless-loop');
      let lastPlaybackTime = 0;
      if (seamlessLoop) video.loop = true;
      const shouldPlay = () => visible && (phone.matches ? tile.classList.contains('is-open') : hovered);
      const hide = () => {
        frameRequest += 1;
        video.classList.remove('is-ready');
      };
      const sync = () => {
        if (!shouldPlay()) {
          video.pause();
          hide();
          return;
        }
        if (completedPlays >= maxVideoPlays) {
          video.pause();
          return;
        }
        if (!ready) {
          load();
          return;
        }
        if (video.ended) video.currentTime = 0;
        if (video.paused) video.play().catch(() => {});
      };
      const reset = () => {
        video.pause();
        hide();
        completedPlays = 0;
        lastPlaybackTime = 0;
        if (video.readyState >= 1) video.currentTime = 0;
      };
      // Fetch the complete file before playback. If the CDN blocks fetch, wait for the native video buffer
      // to cover the full duration instead. The still photo remains visible throughout loading.
      const load = () => {
        if (loading) return;
        loading = true;
        fetch(video.dataset.src).then((response) => {
          if (!response.ok) throw new Error('Video download failed');
          return response.blob();
        }).then((blob) => {
          if (!blob.size) throw new Error('Empty video');
          const url = URL.createObjectURL(blob);
          video.src = url;
          video.preload = 'auto';
          video.load();
          ready = true;
          sync();
        }).catch(() => {
          video.src = video.dataset.src;
          video.preload = 'auto';
          video.load();
          const checkBuffered = () => {
            if (!Number.isFinite(video.duration) || !video.duration || video.buffered.length !== 1) return;
            if (video.buffered.start(0) > .05 || video.buffered.end(0) < video.duration - .05) return;
            ['progress', 'loadedmetadata', 'canplaythrough'].forEach((event) => video.removeEventListener(event, checkBuffered));
            ready = true;
            sync();
          };
          ['progress', 'loadedmetadata', 'canplaythrough'].forEach((event) => video.addEventListener(event, checkBuffered));
          checkBuffered();
        });
      };
      video.addEventListener('playing', () => {
        const request = ++frameRequest;
        const reveal = () => {
          if (request === frameRequest && shouldPlay() && !video.paused) video.classList.add('is-ready');
        };
        if (video.requestVideoFrameCallback) video.requestVideoFrameCallback(reveal);
        // Some mobile browsers defer frame callbacks for an invisible video.
        setTimeout(reveal, 120);
      });
      video.addEventListener('ended', () => {
        completedPlays += 1;
        sync();
      });
      if (seamlessLoop) video.addEventListener('timeupdate', () => {
        if (lastPlaybackTime > video.duration * .75 && video.currentTime < video.duration * .25) {
          completedPlays += 1;
          if (completedPlays >= maxVideoPlays) video.pause();
        }
        lastPlaybackTime = video.currentTime;
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          visible = entry.isIntersecting;
          if (visible) load();
          sync();
        }).observe(tile);
      } else {
        visible = true;
        load();
      }
      tile.addEventListener('pointerenter', (event) => {
        if (phone.matches || event.pointerType === 'touch') return;
        hovered = true;
        sync();
      });
      tile.addEventListener('pointerleave', () => {
        hovered = false;
        if (!phone.matches) reset();
      });
      return { tile, sync, reset };
    };
    const videoControllers = ['hold', 'three', 'ready', 'offline', 'cipher'].map((name) => createVideoController(byName.get(name))).filter(Boolean);
    const videoByTile = new Map(videoControllers.map((controller) => [controller.tile, controller]));
    const toggle = (tile) => {
      const open = tile.classList.toggle('is-open');
      tile.setAttribute('aria-expanded', String(open));
      const controller = videoByTile.get(tile);
      if (controller) {
        controller.reset();
        if (open) controller.sync();
      }
    };
    const setup = () => {
      const order = phone.matches && mobileOrder.every(Boolean) ? mobileOrder : tiles;
      order.forEach((tile, index) => {
        if (grid.children[index] !== tile) grid.insertBefore(tile, grid.children[index] || null);
      });
      tiles.forEach((tile) => {
        if (phone.matches) {
          tile.setAttribute('role', 'button');
          tile.setAttribute('tabindex', '0');
          tile.setAttribute('aria-expanded', String(tile.classList.contains('is-open')));
        } else {
          tile.classList.remove('is-open');
          ['role', 'tabindex', 'aria-expanded'].forEach((name) => tile.removeAttribute(name));
        }
      });
      if (wasMobile !== phone.matches) videoControllers.forEach((controller) => controller.reset());
      wasMobile = phone.matches;
      videoControllers.forEach((controller) => controller.sync());
    };
    tiles.forEach((tile) => {
      tile.addEventListener('click', () => { if (phone.matches) toggle(tile); });
      tile.addEventListener('keydown', (event) => {
        if (!phone.matches || (event.key !== 'Enter' && event.key !== ' ')) return;
        event.preventDefault();
        toggle(tile);
      });
    });
    phone.addEventListener('change', setup);
    setup();
  })();

  (() => {
    const story = document.querySelector('[data-home-demo]');
    if (!story) return;
    // A reload of the homepage starts again from the top, so the hero plays from the start instead of
    // the browser restoring the old scroll position. 'instant' skips the theme's smooth scrolling, whose
    // in-between scroll events would otherwise start the playback.
    const reloaded = performance.getEntriesByType('navigation')[0]?.type === 'reload';
    if (reloaded) {
      history.scrollRestoration = 'manual';
      scrollTo({ top: 0, behavior: 'instant' });
    }
    const screen = story.querySelector('[data-home-demo-screen]');
    const card = story.querySelector('[data-home-demo-card]');
    // Phones and tablets get a lighter version: no idle loop and no scroll hold (it swallows the first swipe).
    const touch = matchMedia('(hover: none) and (pointer: coarse), (max-width: 800px)').matches;
    // Two videos: hero-idle.mp4 is the scan screen loop, hero.mp4 the scan popup and the vault opening.
    // Both sit under the still image, which hides once the idle loop really plays. If a video can't play
    // (Low Power Mode), the stills stay.
    // The idle loop is only 1.2 s long, and a looping <video> stalls for a few frames each time it jumps back
    // to the start. So two copies take turns: the waiting one sits paused on its first frame underneath, starts
    // a few frames before the visible one ends (to cover its start-up delay) and moves on top right after the
    // visible one has shown its last frame. Without requestVideoFrameCallback, one copy simply loops.
    const idleVideos = [...story.querySelectorAll('[data-home-demo-idle]')];
    const idleTurns = 'requestVideoFrameCallback' in HTMLVideoElement.prototype;
    let idleIndex = 0;
    let idleStopped = false;
    const watchIdle = () => {
      const current = idleVideos[idleIndex];
      const next = idleVideos[1 - idleIndex];
      let nextStarted = false;
      let currentDone = false;
      let swapped = false;
      const swap = () => {
        if (swapped || idleStopped) return;
        swapped = true;
        next.style.zIndex = '1';
        current.style.zIndex = '0';
        current.pause();
        current.currentTime = 0;
        idleIndex = 1 - idleIndex;
        watchIdle();
      };
      const onNextFrame = () => {
        if (swapped || idleStopped) return;
        if (currentDone) swap();
        else next.requestVideoFrameCallback(onNextFrame);
      };
      const onCurrentFrame = (now, meta) => {
        if (idleStopped) return;
        if (!nextStarted && meta.mediaTime >= 64 / 60) {
          nextStarted = true;
          next.play().then(() => next.requestVideoFrameCallback(onNextFrame)).catch(() => {});
        }
        if (meta.mediaTime >= 70 / 60 - .001) { currentDone = true; return; }
        current.requestVideoFrameCallback(onCurrentFrame);
      };
      current.addEventListener('ended', () => { currentDone = true; }, { once: true });
      current.requestVideoFrameCallback(onCurrentFrame);
    };
    const stopIdle = () => {
      idleStopped = true;
      idleVideos.forEach((video) => video.pause());
    };
    if (!idleTurns) idleVideos[0].loop = true;
    const idleVideo = idleVideos[0];
    const mainVideo = story.querySelector('[data-home-demo-video]');
    let mainStarted = false;
    let mainFailed = false;
    const playMain = () => {
      mainStarted = true;
      mainVideo.currentTime = 0;
      mainVideo.addEventListener('playing', () => { idleVideos.forEach((video) => { video.style.visibility = 'hidden'; }); screen.style.visibility = 'hidden'; }, { once: true });
      mainVideo.play().catch(() => {
        mainFailed = true;
        idleVideos.forEach((video) => { video.style.visibility = 'hidden'; });
        screen.src = story.dataset.endUrl;
        screen.style.visibility = '';
      });
    };
    const cardDuration = 850;
    const popupDuration = 43 / 60 * 1000;
    const mainDuration = (654 - 181) / 60 * 1000;
    let startedAt = 0;
    let started = false;
    let finished = false;
    const dim = story.querySelector('[data-home-demo-dim]');
    const glow = story.querySelector('[data-home-demo-glow]');
    const render = (elapsed) => {
      if (elapsed >= cardDuration && !mainStarted) playMain();
      // The safety margin ends the loop even if the video stalls for good.
      if (mainVideo.ended || mainFailed || elapsed > cardDuration + popupDuration + mainDuration + 8000) finished = true;
    };
    // The card approach and the glow only animate transform and opacity, so the browser runs them off the
    // main thread; smoothstep easing as before.
    const easing = 'cubic-bezier(.42, 0, .58, 1)';
    const start = () => {
      if (started) return;
      started = true;
      stopIdle();
      startedAt = performance.now();
      const dimmed = getComputedStyle(dim).display !== 'none';
      card.animate([
        { transform: 'translateX(-50%) translateY(24px) scale(.94)', opacity: dimmed ? 1 : 0 },
        { transform: 'translateX(-50%) translateY(0) scale(1)', opacity: 1 }
      ], { duration: cardDuration, easing, fill: 'forwards' });
      if (dimmed) dim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: cardDuration, easing, fill: 'forwards' });
      // The glow flares in fast as soon as the scan popup starts, then fades out. Phones get a softer glow
      // (see the CSS) that rises and fades more slowly.
      if (touch) glow.animate([
        { opacity: 0 },
        { opacity: .85, offset: .25, easing },
        { opacity: 0 }
      ], { duration: 2600, delay: cardDuration });
      else glow.animate([
        { opacity: 0 },
        { opacity: 1, offset: .12, easing },
        { opacity: 0 }
      ], { duration: 1800, delay: cardDuration });
      render(0);
      requestAnimationFrame(animate);
    };
    // Waits until the video can play on (or gives up after maxWait), so playback doesn't start into a stall.
    const whenReady = (video, maxWait) => new Promise((resolve) => {
      if (video.readyState >= 3) { resolve(); return; }
      const done = () => { clearTimeout(timer); video.removeEventListener('canplay', done); resolve(); };
      const timer = setTimeout(done, maxWait);
      video.addEventListener('canplay', done);
    });
    // Start the desktop animation on the first scroll gesture while allowing that gesture to scroll.
    const scrollKeys = new Set(['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'End', 'Home', ' ', 'Spacebar']);
    const release = () => {
      removeEventListener('wheel', intercept);
      removeEventListener('touchmove', intercept);
      removeEventListener('keydown', intercept);
    };
    const intercept = (event) => {
      if (scrollY > 1) { start(); release(); return; }
      if (event.type === 'keydown' && (!scrollKeys.has(event.key) || event.target.closest?.('input, textarea, select, [contenteditable]'))) return;
      start();
      release();
    };
    // Scrollbar drags can't be held back, so a plain scroll still starts the playback.
    const onScroll = () => {
      if (scrollY < 1) return;
      removeEventListener('scroll', onScroll);
      start();
    };
    const animate = (now) => {
      if (finished) return;
      render(now - startedAt);
      requestAnimationFrame(animate);
    };
    // Lit grid cells, as in the videos: a cell flashes in and out every 0.7–1.8 s, sometimes two in a row.
    // On phones the cells glow slower and softer (2.4–3.8 s, varying brightness), and now and then a
    // neighbouring cell lights up after it, like a slow trail. Paused while the hero is off screen or the
    // tab is hidden.
    const grid = story.querySelector('[data-home-demo-grid]');
    const cells = Array.from({ length: touch ? 8 : 4 }, () => grid.appendChild(document.createElement('span')));
    let cellIndex = 0;
    let lastCell = '';
    let gridInView = true;
    const flash = (near) => {
      const size = parseFloat(getComputedStyle(grid).getPropertyValue('--cell')) || 72;
      // The grid is centred (background-position 50%), so the first full column starts at this offset.
      const offset = (grid.clientWidth / 2 - size / 2) % size;
      const columns = Math.floor((grid.clientWidth - offset) / size);
      const rows = Math.floor(grid.clientHeight * .62 / size);
      if (columns < 1 || rows < 2) return;
      let key = lastCell;
      let column = 0;
      let row = 0;
      if (near) {
        // A neighbour of the given cell (left, right, up or down), kept inside the grid.
        const [dx, dy] = [[1, 0], [-1, 0], [0, 1], [0, -1]][Math.floor(Math.random() * 4)];
        column = Math.min(columns - 1, Math.max(0, near.column + dx));
        row = Math.min(rows - 1, Math.max(1, near.row + dy));
        key = `${column}:${row}`;
      }
      while (key === lastCell) {
        column = Math.floor(Math.random() * columns);
        row = 1 + Math.floor(Math.random() * (rows - 1));
        key = `${column}:${row}`;
      }
      lastCell = key;
      const cell = cells[cellIndex++ % cells.length];
      cell.style.left = `${offset + column * size}px`;
      cell.style.top = `${row * size}px`;
      if (touch) {
        cell.animate([
          { opacity: 0, transform: 'scale(.96)' },
          { opacity: .45 + Math.random() * .4, transform: 'scale(1)', offset: .4 },
          { opacity: 0, transform: 'scale(1)' }
        ], { duration: 2400 + Math.random() * 1400, easing: 'ease-in-out' });
        return { column, row };
      }
      cell.animate([
        { opacity: 0, transform: 'scale(.78)' },
        { opacity: 1, transform: 'scale(1)', offset: .32, easing: 'cubic-bezier(.55, 0, .7, .3)' },
        { opacity: 0, transform: 'scale(1.06)' }
      ], { duration: 500, easing: 'cubic-bezier(.2, .8, .3, 1)' });
      return { column, row };
    };
    const twinkle = () => {
      if (gridInView && !document.hidden) {
        const first = flash();
        if (touch) {
          if (first && Math.random() < .45) setTimeout(() => { const second = flash(first); if (second && Math.random() < .4) setTimeout(() => flash(second), 900); }, 900);
        } else if (Math.random() < .3) setTimeout(flash, 220);
      }
      setTimeout(twinkle, touch ? 1100 + Math.random() * 1300 : 700 + Math.random() * 1100);
    };
    new IntersectionObserver(([entry]) => { gridInView = entry.isIntersecting; }).observe(story);

    if (touch) {
      // Phones: nothing holds or handles the scroll, and the sharp first frame stays still (no loop). The light
      // phone video (720 px, 30 fps) loads in the background; after the first touch or scroll the card tap
      // starts as soon as at least 60% of it is loaded. The page itself scrolls normally the whole time.
      twinkle();
      mainVideo.src = mainVideo.dataset.mobileSrc;
      const loaded = () => {
        const { duration, buffered } = mainVideo;
        return duration && buffered.length ? buffered.end(buffered.length - 1) / duration : 0;
      };
      const firstTouch = new Promise((resolve) => {
        const events = ['touchstart', 'touchmove', 'scroll'];
        const go = () => {
          events.forEach((type) => removeEventListener(type, go));
          // iPhones only buffer after a touch, so nudge the (still hidden) video if it hasn't got far yet.
          if (loaded() < .6) mainVideo.play().then(() => { if (!mainStarted) mainVideo.pause(); }).catch(() => {});
          resolve();
        };
        events.forEach((type) => addEventListener(type, go, { passive: true }));
      });
      const enoughLoaded = new Promise((resolve, reject) => {
        const events = ['progress', 'loadeddata', 'canplaythrough'];
        const done = () => { events.forEach((type) => mainVideo.removeEventListener(type, check)); clearInterval(timer); };
        const check = () => { if (mainVideo.readyState >= 4 || loaded() >= .6) { done(); resolve(); } };
        events.forEach((type) => mainVideo.addEventListener(type, check));
        mainVideo.addEventListener('error', () => { done(); reject(new Error('video')); }, { once: true });
        const timer = setInterval(check, 250);
        check();
      });
      firstTouch
        .then(() => enoughLoaded)
        .then(start)
        .catch(() => {
          screen.src = story.dataset.endUrl;
          card.style.setProperty('--home-card-approach', '1');
        });
    } else {
      mainVideo.src = mainVideo.dataset.src;
      idleVideos.forEach((video) => { video.src = video.dataset.src; });
      idleVideo.addEventListener('playing', () => { if (!mainStarted) screen.style.visibility = 'hidden'; }, { once: true });
      idleVideo.play().then(() => { idleVideo.style.zIndex = '1'; if (idleTurns) watchIdle(); }).catch(() => {});
      twinkle();
      const arm = () => {
        addEventListener('wheel', intercept, { passive: true });
        addEventListener('touchmove', intercept, { passive: true });
        addEventListener('keydown', intercept);
        addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      };
      // The browser can restore the old position up to the load event, which would start playback early,
      // so after a reload wait for load, go back to the top, then listen.
      if (reloaded && document.readyState !== 'complete') {
        addEventListener('load', () => { scrollTo({ top: 0, behavior: 'instant' }); requestAnimationFrame(arm); }, { once: true });
      } else {
        arm();
      }
    }
  })();

  // Gen 2 waitlist: Shopify Forms keeps its markup in an open shadow root with hashed class names,
  // so the variables in the stylesheet can't reach the button gradient, heading rhythm or disclaimer.
  // Match the classes by prefix and adopt one extra sheet after the app's own.
  (() => {
    const panel = document.querySelector('.home-waitlist__panel');
    if (!panel || !('adoptedStyleSheets' in Document.prototype)) return;
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(`
      h2[class*="_textHeading_"] { line-height: 1.15; letter-spacing: -.01em; margin: 0 0 .5rem; }
      [class*="_textBody_"] { line-height: 1.55; }
      input[class*="_formInputField_"] { padding-inline: 1.25rem; transition: box-shadow .25s; }
      label[class*="_formInputFieldLabel_"] { left: 1.25rem; }
      button[class*="_formSubmitButton_"] {
        box-sizing: border-box; align-items: center; min-height: 3rem;
        border: 1px solid rgba(232, 186, 163, .5);
        background: var(--gradient-key); background-size: 170% 170%; background-position: 0 50%;
        box-shadow: 0 1px 0 rgba(255, 255, 255, .32) inset, 0 10px 24px -14px rgba(184, 115, 97, .72);
        font-size: .9375rem; font-weight: 650; letter-spacing: .015em;
        transition: background-position .45s var(--ease), border-color .3s var(--ease), box-shadow .3s var(--ease), transform .3s var(--ease);
      }
      button[class*="_formSubmitButton_"]:hover,
      button[class*="_formSubmitButton_"]:focus-visible {
        filter: none; border: 1px solid rgba(232, 186, 163, .88); background-position: 100% 50%;
        box-shadow: 0 1px 0 rgba(255, 255, 255, .38) inset, 0 15px 30px -14px rgba(184, 115, 97, .85);
        transform: translateY(-1px);
      }
      button[class*="_formSubmitButton_"]:active { transform: none; }
      div[class*="_formDisclaimer_"] {
        margin: 1.1rem 0 0 !important; padding: 1.1rem 0 0; border-top: 1px solid var(--line);
        font-size: .75rem; line-height: 1.55; color: var(--quiet);
      }
    `);
    const styled = new WeakSet();
    const style = () => {
      panel.querySelectorAll('shopify-forms-embed').forEach((embed) => {
        const root = embed.shadowRoot;
        if (!root || styled.has(root)) return;
        styled.add(root);
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
      });
    };
    customElements.whenDefined('shopify-forms-embed').then(style);
    new MutationObserver(style).observe(panel, { childList: true, subtree: true });
  })();

  (() => {
    const cardStage = document.querySelector('[data-card-stack]');
    const howRoot = document.querySelector('[data-how-scroll]');
    const howTrack = howRoot?.querySelector('[data-how-track]');
    const threeTrack = document.querySelector('[data-three-track]');
    const threeItems = threeTrack?.querySelectorAll('.three-cards__item');
    const threeCards = threeTrack?.querySelector('.three-cards');
    const mobileCardsUseTimeline = CSS.supports('animation-timeline: view()');
    const flowSections = document.querySelectorAll('[data-flow-section]');
    let frame = 0;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const progressFor = (element, startOffset = 0) => {
      if (!element) return 1;
      const bounds = element.getBoundingClientRect();
      const travel = bounds.height - innerHeight + startOffset;
      return Math.min(1, Math.max(0, (startOffset - bounds.top) / Math.max(travel, 1)));
    };
    const update = () => {
      frame = 0;
      currentX += (targetX - currentX) * .075;
      currentY += (targetY - currentY) * .075;
      if (cardStage) {
        const heroProgress = Math.min(1, Math.max(0, scrollY / Math.max(innerHeight, 1)));
        cardStage.style.setProperty('--rx', `${(-currentY * 6).toFixed(3)}deg`);
        cardStage.style.setProperty('--ry', `${(currentX * 8).toFixed(3)}deg`);
        cardStage.style.setProperty('--sheen', `${(50 + currentX * 40).toFixed(2)}`);
        cardStage.style.setProperty('--hero-scroll', heroProgress.toFixed(4));
      }
      // Desktop: unfolding starts while the section is still 60% of a screen below the top and takes about two
      // screens of scrolling. The 232vh track (critical.css) releases the pin when it is 95% unfolded.
      const cardsTop = innerWidth > 900 && threeTrack ? threeTrack.getBoundingClientRect().top : innerHeight;
      const cardsProgress = innerWidth > 900 ? Math.min(1, Math.max(0, (innerHeight * .6 - cardsTop) / (innerHeight * 2.016))) : 0;
      if (innerWidth > 900) {
        threeTrack?.style.setProperty('--cards-progress', cardsProgress.toFixed(4));
        threeTrack?.style.setProperty('--sheen', String(Math.round(28 + cardsProgress * 48)));
      } else if (threeCards && !mobileCardsUseTimeline) {
        const top = threeCards.getBoundingClientRect().top;
        const progress = Math.min(1, Math.max(0, (innerHeight - top) / (innerHeight * .82)));
        threeTrack.style.setProperty('--cards-progress', progress.toFixed(4));
      }
      if (innerWidth > 900 && threeItems?.length === 3) {
        const stackProgress = 1 - cardsProgress;
        const rotateX = stackProgress * 40;
        const rotateZ = stackProgress * -18;
        const leftPosition = 50 * stackProgress;
        const leftTranslate = -50 * stackProgress;
        const rightPosition = 50 + 50 * cardsProgress;
        const rightTranslate = -50 - 50 * cardsProgress;

        threeItems[0].style.left = `${leftPosition.toFixed(2)}%`;
        threeItems[0].style.transform = `translateX(${leftTranslate.toFixed(2)}%) rotateX(${rotateX.toFixed(2)}deg) rotateZ(${rotateZ.toFixed(2)}deg)`;
        threeItems[1].style.left = '50%';
        threeItems[1].style.transform = `translateX(-50%) translateY(${(-12 * stackProgress).toFixed(2)}px) rotateX(${rotateX.toFixed(2)}deg) rotateZ(${rotateZ.toFixed(2)}deg)`;
        threeItems[2].style.left = `${rightPosition.toFixed(2)}%`;
        threeItems[2].style.transform = `translateX(${rightTranslate.toFixed(2)}%) translateY(${(-24 * stackProgress).toFixed(2)}px) rotateX(${rotateX.toFixed(2)}deg) rotateZ(${rotateZ.toFixed(2)}deg)`;
      } else {
        threeItems?.forEach((item) => {
          item.style.removeProperty('left');
          item.style.removeProperty('transform');
        });
      }
      if (innerWidth > 900) {
        const howProgress = Math.min(1, progressFor(howTrack) / .76);
        howTrack?.style.setProperty('--how-progress', howProgress.toFixed(4));
        if (howRoot) howRoot.dataset.step = howProgress < .32 ? '0' : howProgress < .68 ? '1' : '2';
      } else {
        howTrack?.style.setProperty('--how-progress', '0');
        if (howRoot) howRoot.dataset.step = '0';
      }
      if (innerWidth > 900) flowSections.forEach((section) => {
        const bounds = section.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (innerHeight - bounds.top) / (innerHeight + bounds.height)));
        section.style.setProperty('--flow-y', `${((.5 - progress) * 90).toFixed(2)}px`);
      });
      if (Math.abs(targetX - currentX) > .001 || Math.abs(targetY - currentY) > .001) frame = requestAnimationFrame(update);
    };
    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    if (cardStage && matchMedia('(pointer:fine)').matches) {
      window.addEventListener('pointermove', (event) => {
        targetX = (event.clientX / innerWidth - .5) * 2;
        targetY = (event.clientY / innerHeight - .5) * 2;
        requestUpdate();
      }, { passive: true });
      document.documentElement.addEventListener('pointerleave', () => {
        targetX = 0;
        targetY = 0;
        requestUpdate();
      });
    }
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();
  })();

  // How it works: four steps, about 2.8s each, start when the phone's middle reaches the middle of the screen.
  // The active pagination dot is a line that fills until the next step. Tapping the phone goes to the next step
  // (after step 4 it waits for a tap, which starts again at 1); clicking a step card jumps to that step.
  // Step 4: the card drops in, the "saved" screenshot swaps in, and the glow flashes on that same frame.
  (() => {
    const root = document.querySelector('[data-create]');
    if (!root) return;
    const stage = root.querySelector('[data-create-stage]');
    const phone = root.querySelector('[data-create-phone]');
    const card = root.querySelector('[data-create-card]');
    const steps = [...root.querySelectorAll('[data-create-step]')];
    const screens = [...root.querySelectorAll('[data-create-screen]')];
    const dots = [...(root.querySelector('[data-create-progress]')?.children || [])];
    const STEP = 2800;
    const LAST = 2600;
    const CARD_IN = 650;
    const SAVED_AT = 700;
    const GLOW = 1600;
    const clamp = (value) => Math.min(1, Math.max(0, value));
    const smooth = (value) => value * value * (3 - 2 * value);
    let state = 'idle';
    let step = 0;
    let stepStart = 0;
    let running = false;
    let approach = 0;
    let cardFrom = 0;
    let cardLeftAt = -Infinity;

    const paint = (now) => {
      let local = state === 'idle' ? 0 : now - stepStart;
      while (state === 'playing' && step < 3 && local >= STEP) {
        step += 1;
        stepStart += STEP;
        local -= STEP;
      }
      if (state === 'playing' && step === 3 && local >= LAST) state = 'done';
      const duration = step === 3 ? LAST : STEP;
      steps.forEach((item, index) => item.classList.toggle('is-active', index === step));
      screens.forEach((item, index) => item.classList.toggle('is-active', index === (step < 3 ? step : local >= SAVED_AT ? 3 : 2)));
      dots.forEach((item, index) => {
        item.classList.toggle('is-done', index < step);
        item.classList.toggle('is-active', index === step);
        item.style.setProperty('--p', index === step ? clamp(local / duration).toFixed(4) : '0');
      });
      approach = step === 3 ? smooth(clamp(local / CARD_IN)) : cardFrom * (1 - smooth(clamp((now - cardLeftAt) / 350)));
      card.style.setProperty('--approach', approach.toFixed(3));
      // Lights up within ~60ms of the screenshot swap, then fades out slowly over ~1.5s.
      const glow = step === 3 ? (local - SAVED_AT) / GLOW : -1;
      stage.style.setProperty('--glow', (glow < 0 || glow > 1 ? 0 : glow < .04 ? glow / .04 : (1 - (glow - .04) / .96) ** 2).toFixed(3));
    };
    const tick = (now) => {
      paint(now);
      const settling = now - cardLeftAt < 400;
      if (state === 'playing' || settling) requestAnimationFrame(tick);
      else running = false;
    };
    const run = () => {
      if (running) return;
      running = true;
      requestAnimationFrame(tick);
    };
    const go = (index) => {
      const now = performance.now();
      if (step === 3 && index !== 3) {
        cardFrom = approach;
        cardLeftAt = now;
      }
      step = index;
      stepStart = now;
      state = 'playing';
      run();
    };

    phone.addEventListener('click', () => go(state === 'idle' ? 1 : (step + 1) % 4));
    root.querySelectorAll('[data-create-goto]').forEach((button) => {
      button.addEventListener('click', () => go(Number(button.dataset.createGoto)));
    });

    const check = () => {
      const box = stage.getBoundingClientRect();
      const middle = box.top + box.height / 2;
      if (state === 'idle' && middle <= innerHeight / 2 + 40 && box.bottom > 0) go(0);
      const away = box.bottom < -innerHeight * .25 || box.top > innerHeight * 1.25;
      if (state === 'done' && away) {
        state = 'idle';
        step = 0;
        cardFrom = 0;
        paint(performance.now());
      }
    };
    paint(performance.now());
    addEventListener('scroll', check, { passive: true });
    addEventListener('resize', check);
    check();
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mi8os-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let animationFrame = 0;

    const update = () => {
      animationFrame = 0;

      document.querySelectorAll('[data-object-scroll]').forEach((section) => {
        const track = section.querySelector('[data-object-scroll-track]');
        if (!track) return;

        const bounds = track.getBoundingClientRect();
        // Compact: no sticky track, so the card turns while its centre moves from 70% to 30% of the screen height.
        const compact = section.classList.contains('object-scroll--compact');
        const stage = compact && section.querySelector('.object-scroll__stage');
        const stageBounds = stage && stage.getBoundingClientRect();
        const raw = stageBounds
          ? (innerHeight * .7 - (stageBounds.top + stageBounds.height / 2)) / (innerHeight * .4)
          : -bounds.top / Math.max(bounds.height - innerHeight, 1);
        const progress = Math.min(Math.max(raw, 0), 1);
        const eased = progress * progress * (3 - 2 * progress);
        const lift = Math.sin(progress * Math.PI) * -18 + 12;
        const drift = -2 + Math.sin(progress * Math.PI) * 4;

        section.style.setProperty('--object-progress', progress.toFixed(4));
        section.style.setProperty('--object-rotation', `${(eased * 180).toFixed(3)}deg`);
        section.style.setProperty('--object-lift', `${lift.toFixed(3)}px`);
        section.style.setProperty('--object-drift', `${drift.toFixed(3)}deg`);
      });
    };

    const requestUpdate = () => {
      if (!animationFrame) animationFrame = requestAnimationFrame(update);
    };

    addEventListener('scroll', requestUpdate, { passive: true });
    addEventListener('resize', requestUpdate, { passive: true });
    document.addEventListener('shopify:section:load', requestUpdate);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  document.querySelectorAll('[data-password-language-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const finePointer = matchMedia('(pointer: fine)').matches;
    const interactiveMedia = [...root.querySelectorAll('[data-interactive-media]')];
    const gallery = root.querySelector('[data-product-gallery]');
    const mediaPanels = [...(gallery?.querySelectorAll('[data-media-panel]') || [])];
    const mediaThumbnails = [...(gallery?.querySelectorAll('[data-media-thumbnail]') || [])];

    const selectMedia = (thumbnail, moveFocus = false) => {
      const target = thumbnail.dataset.mediaTarget;
      mediaPanels.forEach((panel) => {
        const selected = panel.dataset.mediaPanel === target;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });
      mediaThumbnails.forEach((item) => {
        const selected = item === thumbnail;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      if (moveFocus) thumbnail.focus();
    };

    mediaThumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => selectMedia(thumbnail));
      thumbnail.addEventListener('keydown', (event) => {
        const navigationKeys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
        if (!navigationKeys.includes(event.key)) return;
        let nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % mediaThumbnails.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + mediaThumbnails.length) % mediaThumbnails.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = mediaThumbnails.length - 1;
        event.preventDefault();
        selectMedia(mediaThumbnails[nextIndex], true);
      });
    });

    if (finePointer) {
      interactiveMedia.forEach((mediaPanel) => {
        const movingObject = mediaPanel.querySelector('[data-product-card-stack], [data-product-object]');
        if (!movingObject) return;
        let targetX = 0;
        let targetY = 0;
        let currentX = 0;
        let currentY = 0;
        let animationFrame = 0;

        const updateObject = () => {
          animationFrame = 0;
          currentX += (targetX - currentX) * .075;
          currentY += (targetY - currentY) * .075;
          movingObject.style.setProperty('--rx', `${(-currentY * 6).toFixed(3)}deg`);
          movingObject.style.setProperty('--ry', `${(currentX * 8).toFixed(3)}deg`);
          movingObject.style.setProperty('--sheen', `${(50 + currentX * 40).toFixed(2)}`);
          if (Math.abs(targetX - currentX) > .001 || Math.abs(targetY - currentY) > .001) {
            animationFrame = requestAnimationFrame(updateObject);
          }
        };

        const requestObjectUpdate = () => {
          if (!animationFrame) animationFrame = requestAnimationFrame(updateObject);
        };

        mediaPanel.addEventListener('pointermove', (event) => {
          const bounds = mediaPanel.getBoundingClientRect();
          targetX = ((event.clientX - bounds.left) / bounds.width - .5) * 2;
          targetY = ((event.clientY - bounds.top) / bounds.height - .5) * 2;
          mediaPanel.style.setProperty('--pointer-x', `${((targetX + 1) * 50).toFixed(2)}%`);
          mediaPanel.style.setProperty('--pointer-y', `${((targetY + 1) * 50).toFixed(2)}%`);
          requestObjectUpdate();
        }, { passive: true });

        mediaPanel.addEventListener('pointerleave', () => {
          targetX = 0;
          targetY = 0;
          mediaPanel.style.setProperty('--pointer-x', '50%');
          mediaPanel.style.setProperty('--pointer-y', '45%');
          requestObjectUpdate();
        });
      });
    }

    if (!finePointer && gallery) {
      const movingMedia = interactiveMedia.map((mediaPanel, index) => ({
        index,
        mediaPanel,
        movingObject: mediaPanel.querySelector('[data-product-card-stack], [data-product-object]')
      })).filter((item) => item.movingObject);
      let loopFrame = 0;
      let galleryVisible = false;

      const updateMobileLoop = (time) => {
        if (!galleryVisible) {
          loopFrame = 0;
          return;
        }

        movingMedia.forEach(({ index, mediaPanel, movingObject }) => {
          const phase = time / 1800 + index * .7;
          const horizontal = Math.sin(phase);
          const vertical = Math.cos(phase * .82);
          movingObject.style.setProperty('--rx', `${(vertical * 2.4).toFixed(3)}deg`);
          movingObject.style.setProperty('--ry', `${(horizontal * 4).toFixed(3)}deg`);
          movingObject.style.setProperty('--sheen', `${(50 + horizontal * 28).toFixed(2)}`);
          mediaPanel.style.setProperty('--pointer-x', `${(50 + horizontal * 12).toFixed(2)}%`);
          mediaPanel.style.setProperty('--pointer-y', `${(45 + vertical * 9).toFixed(2)}%`);
        });

        loopFrame = requestAnimationFrame(updateMobileLoop);
      };

      const galleryObserver = new IntersectionObserver((entries) => {
        galleryVisible = entries[0].isIntersecting;
        if (galleryVisible && !loopFrame) loopFrame = requestAnimationFrame(updateMobileLoop);
      }, { rootMargin: '120px' });

      galleryObserver.observe(gallery);
    }

    const form = root.querySelector('[data-product-form]');
    const button = root.querySelector('[name="add"]');
    const mobileBar = root.nextElementSibling?.matches('[data-mobile-purchase]') ? root.nextElementSibling : null;
    const mobileButton = mobileBar?.querySelector('[data-mobile-add]');
    const mobilePrice = mobileBar?.querySelector('[data-mobile-price]');

    form?.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-product-quantity-action]');
      if (!quantityButton) return;
      const quantityInput = quantityButton.closest('.product-quantity')?.querySelector('input[name="quantity"]');
      if (!quantityInput) return;
      if (quantityButton.dataset.productQuantityAction === 'increase') {
        quantityInput.stepUp();
      } else {
        quantityInput.stepDown();
      }
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    mobileButton?.addEventListener('click', () => {
      if (form && button) form.requestSubmit(button);
    });

    if (mobileBar && button) {
      const mobileQuery = matchMedia('(max-width: 800px)');
      let formButtonVisible = false;
      const syncMobileBar = () => {
        const visible = !mobileQuery.matches || !formButtonVisible;
        mobileBar.classList.toggle('is-visible', visible);
        mobileBar.setAttribute('aria-hidden', String(!visible));
        mobileBar.inert = !visible;
      };
      const buttonObserver = new IntersectionObserver((entries) => {
        formButtonVisible = entries[0].isIntersecting;
        syncMobileBar();
      }, { threshold: .15 });
      buttonObserver.observe(button);
      mobileQuery.addEventListener('change', syncMobileBar);
      syncMobileBar();
    }

    const select = root.querySelector('[data-variant-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      const price = root.querySelector('[data-product-price]');
      const current = price?.querySelector('.price__current');
      const compare = price?.querySelector('.price__compare');
      const status = root.querySelector('[data-product-status]');
      if (current) current.textContent = option.dataset.price;
      if (mobilePrice) mobilePrice.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare;
        compare.hidden = !option.dataset.compare;
      } else if (price && option.dataset.compare) {
        const node = document.createElement('s');
        node.className = 'price__compare';
        node.textContent = option.dataset.compare;
        price.append(node);
      }
      if (button) {
        button.disabled = !available;
        const label = button.querySelector('[data-purchase-label]') || button;
        label.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
      }
      if (mobileButton) {
        mobileButton.disabled = !available;
        mobileButton.textContent = available ? button.dataset.addLabel : root.dataset.soldOutLabel;
      }
      if (status) {
        status.textContent = available ? root.dataset.inStockLabel : root.dataset.soldOutLabel;
        status.classList.toggle('is-sold-out', !available);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
